import { render, staticRenderFns } from "./ManageTable.vue?vue&type=template&id=6cbf41a0&scoped=true&"
import script from "./ManageTable.vue?vue&type=script&lang=js&"
export * from "./ManageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf41a0",
  null
  
)

export default component.exports